import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Text, useStyleConfig} from '@chakra-ui/react'
import DynamicImage from '../../dynamic-image'
import EnergyLabel from '../../energy-label'
import {FormattedMessage, useIntl} from 'react-intl'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import useProductData from '../../../hooks/use-product-data'
import {PRODUCT_LIST_SELECTABLE_ATTRIBUTE_ID} from '@salesforce/retail-react-app/app/constants'
import OmnibusPrice from '../../display-price/omnibus-price'
import {getImageForProductTile} from '../../../utils/utils'
import {useBooleanCustomPreference} from '../../../hooks/use-custom-preference'

const ProductCompareTile = ({product}) => {
    const styles = useStyleConfig('ProductCompare')
    const {currency} = useCurrency()
    const intl = useIntl()
    const notShoppableCountry = useBooleanCustomPreference('notShoppableCountry')
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    const {productUrl, priceData} = useProductData(product, PRODUCT_LIST_SELECTABLE_ATTRIBUTE_ID)
    const listPriceText = intl.formatNumber(product?.price, {
        style: 'currency',
        currency: product?.currency || currency,
    })

    const imgSrc = getImageForProductTile(product)

    return (
        <Flex {...styles?.productCompareTile} data-testid="product-compare-tile">
            {imgSrc ? (
                <DynamicImage
                    data-testid="dynamic-image"
                    src={imgSrc}
                    {...styles?.productCompareTileImage}
                />
            ) : (
                <></>
            )}

            <Text {...styles?.productNameLabel}>{product?.name}</Text>
            <Text {...styles?.productIdLabel}>{product?.variationValues?.subModelIdentifier}</Text>
            {!notShoppableCountry && (
                <>
                    <Text {...styles?.productPriceLabel}>{listPriceText}</Text>
                    <Text as="div" {...styles?.productRetailPriceLabel}>
                        {priceData.showOmnibusPriceDiscount ? (
                            <OmnibusPrice
                                priceData={priceData}
                                currency={currency}
                                omnibusExpandedView
                                variant="recommended"
                            />
                        ) : (
                            product?.price !== priceData.listPrice && (
                                <Text>
                                    {priceData.listPrice}{' '}
                                    <FormattedMessage
                                        defaultMessage="Retail prices"
                                        id="product-compare.tile.retail_price"
                                    />
                                </Text>
                            )
                        )}
                    </Text>
                </>
            )}

            {product?.c_energyEfficiencyClass && (
                <EnergyLabel
                    level={product.c_energyEfficiencyClass}
                    description="Energy information"
                    width="100%"
                    justifyContent="center"
                    manualDocument={product?.c_manualDocument}
                />
            )}
        </Flex>
    )
}

ProductCompareTile.propTypes = {
    product: PropTypes.object,
}

export default ProductCompareTile
